<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  mounted(){
    if(localStorage.getItem("token")== null){
      this.$router.push({path:'/login'})
    }
  }
};
</script>

<style lang="less">
@import "@assets/css/main.css";
// 浏览器滚动条
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: #F5F7FA;
}
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: #e8e8e8;
}
@font-face {  
  font-family: 'YouSheBiaoTiHei';  
  src: url('@/assets/fonts/youshebiaotihei.ttf') format('truetype');  
  font-weight: normal;  
  font-style: normal;  
}  
</style>
